import React from 'react'
import { Box, Button } from '@mui/material'
import { GridInfoCard } from 'components/atoms/InfoCard'
import { InfoCardIcon } from 'components/atoms/Icons'
import { getLocalUser } from 'utils/localStorage'
import { useTranslation } from 'react-i18next'
import HeaderWithInfoCards, {
  Welcome
} from 'components/atoms/container/HeaderWithInfoCards'
import collaborationTeamIcon from 'assets/images/collaborationTeamChat.svg'
import connectionsIcon from 'assets/images/connections.svg'
import listFavoriteStarIcon from 'assets/images/listFavoriteStar.svg'

const CheckInSurveyLanding = ({ handleBegin }) => {
  const { t } = useTranslation()
  const name = getLocalUser().firstName || t('rolePlay.upcomingLeader')

  return (
    <HeaderWithInfoCards
      welcomeElement={
        <Welcome
          headLine={`${t('rolePlay.hi')} , ${name}`}
          title={t('checkInSurvey.oneOneOneCheckinSurvey')}
          description={t('checkInSurvey.welcomeToYourPersonalizedOneOnOne')}>
          <Box sx={{ paddingTop: 6 }}>
            <Button
              sx={{ width: 170, textWrap: 'nowrap' }}
              onClick={handleBegin}>
              {t('checkInSurvey.beginCheckin')}
            </Button>
          </Box>
        </Welcome>
      }>
      <GridInfoCard
        title={t('checkInSurvey.highlightChallenges')}
        content={t('checkInSurvey.highlightChallengesDesc')}
        icon={<InfoCardIcon src={listFavoriteStarIcon} size={64} />}
      />
      <GridInfoCard
        title={t('checkInSurvey.sparkDeeperConversations')}
        content={t('checkInSurvey.sparkDeeperConversationsDesc')}
        icon={<InfoCardIcon src={collaborationTeamIcon} size={64} />}
      />
      <GridInfoCard
        title={t('checkInSurvey.setupForSuccess')}
        content={t('checkInSurvey.setupForSuccessDesc')}
        icon={<InfoCardIcon src={connectionsIcon} size={64} />}
      />
    </HeaderWithInfoCards>
  )
}

export default CheckInSurveyLanding
